module.exports = __webpack_public_path__ + "img/djj1.498f68b7.png";